var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _circle, _path18, _g, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _g2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g3, _path53, _path54, _path55, _path56, _path57, _g4, _path58, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_60312",
    "data-name": "Group 60312",
    xmlns: "http://www.w3.org/2000/svg",
    width: 229.868,
    height: 85.1,
    viewBox: "0 0 229.868 85.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_31127",
    "data-name": "Path 31127",
    d: "M824.747,755.346c0,1.829-51.458,3.312-114.934,3.312s-114.934-1.483-114.934-3.312,51.458-3.312,114.934-3.312S824.747,753.517,824.747,755.346Z",
    transform: "translate(-594.879 -673.558)",
    fill: "#bcc0c9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31128",
    "data-name": "Path 31128",
    d: "M823.41,757.024c0,.9-42.764,1.632-95.515,1.632s-95.515-.73-95.515-1.632,42.763-1.631,95.515-1.631S823.41,756.123,823.41,757.024Z",
    transform: "translate(-613.617 -675.236)",
    fill: "#231f20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31129",
    "data-name": "Path 31129",
    d: "M849.625,700.111c0-10.28-4.353-18.7-9.862-19.387v-.047h-12.62c-5.851,0-10.595,8.7-10.595,19.434s4.743,19.433,10.595,19.433h12.62V719.5C845.273,718.807,849.625,710.392,849.625,700.111Z",
    transform: "translate(-705.634 -637.905)",
    fill: "#231f20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31130",
    "data-name": "Path 31130",
    d: "M670.1,700.111c0-10.28-4.353-18.7-9.862-19.387v-.047h-12.62c-5.851,0-10.595,8.7-10.595,19.434s4.743,19.433,10.595,19.433h12.62V719.5C665.743,718.807,670.1,710.392,670.1,700.111Z",
    transform: "translate(-615.934 -637.905)",
    fill: "#231f20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6053",
    "data-name": "Rectangle 6053",
    d: "M0,0H116.174a0,0,0,0,1,0,0V0A32.379,32.379,0,0,1,83.795,32.379H0a0,0,0,0,1,0,0V0A0,0,0,0,1,0,0Z",
    transform: "translate(93.178 39.127)",
    fill: "#231f20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31131",
    "data-name": "Path 31131",
    d: "M731.945,666.7h55.416a3.2,3.2,0,0,0,3.184-2.977c.109-1.542.288-3.123.54-4.73,2.168-13.793,8.943-24.186,15.133-23.213s9.45,12.944,7.282,26.737q-.168,1.067-.372,2.105a.474.474,0,0,0,.84.38,27.469,27.469,0,0,0,5.205-22.968c-1.235-5.518-2.538-11.3-3.3-14.589a6.176,6.176,0,0,0-2.722-3.825C797.672,613.828,781.777,599,749.7,596.01c-22.667-2.115-52.911.247-61.213,2.966A102.232,102.232,0,0,0,654.528,618.5c-41.507,9.392-37.985,21.5-37.985,41.03.034,3.947,2.767,7.168,8.8,7.168h73.179a4.141,4.141,0,0,0,4.132-3.886c.093-1.481.262-3,.513-4.531,2.214-13.512,9.935-23.494,17.246-22.3s11.443,13.122,9.229,26.634q-.09.548-.192,1.088A2.53,2.53,0,0,0,731.945,666.7Z",
    transform: "translate(-605.666 -595.194)",
    fill: "#5b6161"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31132",
    "data-name": "Path 31132",
    d: "M743.665,602.229c20.009-3.785,49.241-5.706,74.776-5.613q-2.523-.354-5.187-.606c-22.667-2.115-52.911.247-61.213,2.966A88.141,88.141,0,0,0,743.665,602.229Z",
    transform: "translate(-669.218 -595.194)",
    fill: "#a3a8a8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31133",
    "data-name": "Path 31133",
    d: "M666.073,641.405c-12.426,2.813-20.813,5.869-26.468,9.3,8.352-2.791,24.075-9.405,61.658-9.361C689.742,640.779,674.651,641.077,666.073,641.405Z",
    transform: "translate(-617.226 -618.094)",
    fill: "#a3a8a8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31134",
    "data-name": "Path 31134",
    d: "M783.645,680.678c-6.515,0-11.8,8.7-11.8,19.434s5.282,19.433,11.8,19.433H797.7V680.678Z",
    transform: "translate(-683.3 -637.905)",
    fill: "#231f20"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31135",
    "data-name": "Path 31135",
    d: "M958.654,680.678c-5.851,0-10.595,8.7-10.595,19.434s4.744,19.433,10.595,19.433h12.62V680.678Z",
    transform: "translate(-771.342 -637.905)",
    fill: "#231f20"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31136",
    "data-name": "Path 31136",
    d: "M631.622,671.546c-5.123,0-6.035-2.759-6.035-2.759a13.135,13.135,0,0,1-.8-2.014,19.323,19.323,0,0,0-6.006,9.4h0c1.412.882,2.274,2.489,3.681,6.43C622.464,682.608,628.547,674.62,631.622,671.546Z",
    transform: "translate(-606.822 -630.958)",
    fill: "#353538"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31137",
    "data-name": "Path 31137",
    d: "M705.754,678.421c3.049-4.031,7.992-7.656,16.066-7.656s13.677,1.295,18.538-2.2,26.862-15.606,26.862-15.606c-10.549,0-31.237,2.712-55.624,10.221a29.334,29.334,0,0,1-10.77,1.547C697.186,664.731,701.019,675.074,705.754,678.421Z",
    transform: "translate(-647.093 -624.058)",
    fill: "#353538"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31138",
    "data-name": "Path 31138",
    d: "M813.239,680.379a.614.614,0,0,0,1.1.477,27.469,27.469,0,0,0,4.839-22.491c-1.266-5.653-2.6-11.586-3.354-14.827a5.589,5.589,0,0,0-2.471-3.464c-5.787-3.645-11.623-8-18.331-12.193-4.029,15.857-32.249,11.492-68.537,12.525-13.191.376-21.691,5.4-27.219,12.224a62.742,62.742,0,0,1-48.783,23.11H626.708a10.586,10.586,0,0,1-10.239-7.9h0c0,2.529.074,5.2.074,8.023,0,.071,0,.141,0,.211,0,.016,0,.032,0,.048,0,.1.01.2.018.3,0,.053.009.107.014.16s.009.089.014.134c.4,3.55,3.154,6.319,8.752,6.319h73.759a3.528,3.528,0,0,0,3.523-3.354,45.331,45.331,0,0,1,.543-5.064c2.214-13.512,9.935-23.494,17.246-22.3s11.443,13.122,9.229,26.634q-.116.7-.251,1.393a2.251,2.251,0,0,0,2.208,2.687H787.29a3.274,3.274,0,0,0,3.261-3.048c.109-1.52.286-3.077.535-4.658,2.168-13.793,8.943-24.186,15.133-23.213s9.45,12.944,7.282,26.737Q813.38,679.621,813.239,680.379Z",
    transform: "translate(-605.666 -611.526)",
    fill: "#272729"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31139",
    "data-name": "Path 31139",
    d: "M710.865,655.908c8.883-5.38,27.055-13.712,52.447-15.119h20.7c-15.244,0-45.94,4.763-72.8,15.9C710.747,656.882,710.429,656.172,710.865,655.908Z",
    transform: "translate(-652.727 -617.975)",
    fill: "#353538"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31140",
    "data-name": "Path 31140",
    d: "M734.275,697.267h-5.815A17.037,17.037,0,0,0,716.8,701.88l-7.813,7.329,6.917,3.73a10.6,10.6,0,0,0,5.889.405l16.978-3.678Z",
    transform: "translate(-651.893 -646.194)",
    fill: "#303033"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31141",
    "data-name": "Path 31141",
    d: "M657.645,700.577H635.536a5.9,5.9,0,0,1-5.363-3.437l-3.687-10.012a5.644,5.644,0,0,1,1.407-6.04l2.412-2.295a5.842,5.842,0,0,1,3.551-1.2h29.938a5.839,5.839,0,0,1,3.335,1.046l2.024,1.709a5.644,5.644,0,0,1,1.125,7.336l-6.049,9.535A8.132,8.132,0,0,1,657.645,700.577Z",
    transform: "translate(-610.497 -636.363)",
    fill: "#231f20"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31142",
    "data-name": "Path 31142",
    d: "M618.01,697.279l4.315,12.164-2.931,1.709-1.384-.738-1.448-3.284Z",
    transform: "translate(-605.713 -646.2)",
    fill: "#353538"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31143",
    "data-name": "Path 31143",
    d: "M832.978,660.779c12.04,2,70.6,3.573,77.789-1.213C893.829,659.563,832.978,660.779,832.978,660.779Z",
    transform: "translate(-713.843 -627.357)",
    fill: "#515757"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31144",
    "data-name": "Path 31144",
    d: "M907.273,656.638a3.006,3.006,0,1,0-3.006,3.006A3.006,3.006,0,0,0,907.273,656.638Z",
    transform: "translate(-747.96 -624.392)",
    fill: "#231f20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3207",
    "data-name": "Ellipse 3207",
    cx: 3.006,
    cy: 3.006,
    r: 3.006,
    transform: "translate(181.229 29.24)",
    fill: "#231f20"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31145",
    "data-name": "Path 31145",
    d: "M847.423,696.805h57.22l5.437-13.135s4.756-9.271,2.75-6.56c-7.957,10.753-15.423,18-64.946,18C846.929,695.392,847.423,696.805,847.423,696.805Z",
    transform: "translate(-720.996 -635.874)",
    fill: "#515757"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_60305",
    "data-name": "Group 60305",
    transform: "translate(15.793 43.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6054",
    "data-name": "Rectangle 6054",
    width: 41.808,
    height: 1.236,
    transform: "translate(1.603 0)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6055",
    "data-name": "Rectangle 6055",
    width: 44.844,
    height: 1.236,
    transform: "translate(0 3.284)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6056",
    "data-name": "Rectangle 6056",
    width: 43.793,
    height: 1.236,
    transform: "translate(0.196 6.568)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6057",
    "data-name": "Rectangle 6057",
    width: 40.455,
    height: 1.236,
    transform: "translate(1.603 9.852)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6058",
    "data-name": "Rectangle 6058",
    width: 37.613,
    height: 1.236,
    transform: "translate(2.651 13.135)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6059",
    "data-name": "Rectangle 6059",
    width: 34.057,
    height: 1.236,
    transform: "translate(3.883 16.419)",
    fill: "#48494a"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31146",
    "data-name": "Path 31146",
    d: "M619.347,709.691h0l1.266-.738h0a6.586,6.586,0,0,1-2.5-5.164v-7.072a2.769,2.769,0,0,0-1.339-2.363c-.488,4.233-.253,8.906-.234,14.111l1.655,1.272A1.278,1.278,0,0,0,619.347,709.691Z",
    transform: "translate(-605.666 -644.739)",
    fill: "#231f20"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31147",
    "data-name": "Path 31147",
    d: "M672.992,733.578l-6.809-3.761a6.2,6.2,0,0,0-3-.771H629.252a6.189,6.189,0,0,0-3.659,1.194l-2.689,1.972a10.674,10.674,0,0,0,5.659,1.365Z",
    transform: "translate(-608.881 -662.073)",
    fill: "#231f20"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31148",
    "data-name": "Path 31148",
    d: "M907.47,634.01c-.924-2.238-1.931-3.725-2.99-4.42l-.271.413c.975.64,1.919,2.051,2.8,4.2a24.627,24.627,0,0,1-.187,18.957l-8.924,20.9a8.872,8.872,0,0,1-7.943,5.047h-9.606a11.928,11.928,0,0,0,1.458-5.7l1.977-26.21v-.018c0-2.437-1.369-5.654-2.518-7.925-.667-1.319-1.315-2.432-1.741-3.134a13.078,13.078,0,0,0-.831-1.279c-.039-.087-.1-.207-.184-.378l-.443.22c.047.094.156.317.2.4l0,.01.008.015,0,.01h0a.286.286,0,0,0,.087.1c.632.891,4.914,7.8,4.92,11.946l-1.976,26.21v.019a11.443,11.443,0,0,1-1.531,5.707h-27.43a3.827,3.827,0,0,1-3.793-3.852v-27.51c0-3.992-3.117-9.705-6.014-13.324l-.386.309c2.935,3.667,5.905,9.315,5.905,13.016v27.51a4.322,4.322,0,0,0,4.287,4.346h37.6a9.372,9.372,0,0,0,8.393-5.338l8.929-20.914A25.125,25.125,0,0,0,907.47,634.01Z",
    transform: "translate(-718.432 -612.38)",
    fill: "#231f20"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31149",
    "data-name": "Path 31149",
    d: "M905.455,659.633l-5.583-.076a1.174,1.174,0,0,1-1.158-1.187h0a1.174,1.174,0,0,1,1.19-1.16l5.583.076a1.174,1.174,0,0,1,1.158,1.187h0A1.175,1.175,0,0,1,905.455,659.633Z",
    transform: "translate(-746.686 -626.179)",
    fill: "#b4b7bf"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31150",
    "data-name": "Path 31150",
    d: "M961.975,659.639l-5.223-.072a1.138,1.138,0,0,1-1.082-1.186h0a1.137,1.137,0,0,1,1.114-1.161l5.223.071a1.137,1.137,0,0,1,1.082,1.186h0A1.138,1.138,0,0,1,961.975,659.639Z",
    transform: "translate(-775.144 -626.185)",
    fill: "#b4b7bf"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31151",
    "data-name": "Path 31151",
    d: "M803.439,667.281c-9.218-1.511-18.9,10.744-21.624,27.371a53.931,53.931,0,0,0-.713,8h.9a2.862,2.862,0,0,0,2.862-2.757,45.177,45.177,0,0,1,.569-5.661c2.214-13.512,9.935-23.494,17.246-22.3s11.443,13.122,9.229,26.634q-.146.891-.324,1.761a1.939,1.939,0,0,0,1.9,2.319h1.236q.264-1.248.476-2.533C817.921,683.495,812.657,668.791,803.439,667.281Z",
    transform: "translate(-687.923 -631.149)",
    fill: "#353538"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31152",
    "data-name": "Path 31152",
    d: "M984.89,701.3q.245-.315.479-.636a11.6,11.6,0,0,0,2.2-6.017c1-14.018-3.039-25.407-9.884-26.483-7.693-1.209-16.013,11.067-18.583,27.42a62.438,62.438,0,0,0-.727,7.535h.056a2.934,2.934,0,0,0,2.93-2.739c.107-1.617.291-3.279.556-4.968,2.168-13.793,8.943-24.186,15.133-23.213s9.45,12.944,7.282,26.737q-.156.99-.343,1.955A.51.51,0,0,0,984.89,701.3Z",
    transform: "translate(-776.494 -631.611)",
    fill: "#353538"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31153",
    "data-name": "Path 31153",
    d: "M867.563,602.833c-11.614-.036-18.824,9.51-25.024,17.1a1.158,1.158,0,0,0,.9,1.892H895.57a11,11,0,0,0,9.446-5.191h0C896.436,609.94,884.333,604.734,867.563,602.833Z",
    transform: "translate(-718.488 -599.011)",
    fill: "#b8fffb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31154",
    "data-name": "Path 31154",
    d: "M883.51,618.806h0a7.862,7.862,0,0,0-7.668,6.128l-1.078,4.766h13.161l.946-4.185A5.5,5.5,0,0,0,883.51,618.806Z",
    transform: "translate(-734.721 -606.992)",
    fill: "#596b6a"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31155",
    "data-name": "Path 31155",
    d: "M854.837,607.126a78.262,78.262,0,0,1,17.019.363c10.26,1.578,20.021,6.3,21.659,7.878s2.56,2.575-5.979,1.945c-7.938-.585-13.085-.884-19.388-.884H853.69s-2.269-2.026-4.862-3.912c-2.268,2.425-4.329,5.019-6.288,7.417a1.158,1.158,0,0,0,.9,1.892H895.57a11,11,0,0,0,9.446-5.191c-8.58-6.694-20.683-11.9-37.453-13.8A21.361,21.361,0,0,0,854.837,607.126Z",
    transform: "translate(-718.488 -599.011)",
    fill: "#596b6a"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31156",
    "data-name": "Path 31156",
    d: "M855.566,615.105c6.741-3.943,15.227-5.615,26.021-4.543a67.537,67.537,0,0,1,27.777,8.59c.648-.245,1.542-1.645,1.542-1.645-10.781-7.58-27.062-13.677-38.613-12.853S855.518,614.68,855.566,615.105Z",
    transform: "translate(-725.128 -599.883)",
    fill: "#fff",
    opacity: 0.65
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31157",
    "data-name": "Path 31157",
    d: "M867.393,602.833h-.066c-11.576,0-18.77,9.525-24.958,17.1a1.175,1.175,0,0,0-.135.209l-.07.084a.973.973,0,0,0,.745,1.6H895.4a11.513,11.513,0,0,0,1.55-.106h0c.12-.016.238-.034.357-.055h0q.177-.03.353-.065h0c.117-.024.234-.05.35-.077h0c.117-.027.233-.057.348-.088h0a10.808,10.808,0,0,0,6.483-4.8h0C896.266,609.94,884.162,604.734,867.393,602.833Zm-17.925,17.756-.713-6.356c4.911-5.451,10.681-10.163,18.567-10.165q2.036.233,4.006.533a53.474,53.474,0,0,1,3.979,15.987Zm45.931,0h-15.09c-.549-2.95-2.143-10.514-4.812-15.257a75.612,75.612,0,0,1,18.633,6.1,51.432,51.432,0,0,1,2.588,9.073A10.2,10.2,0,0,1,895.4,620.589Zm2.733-.374a56.084,56.084,0,0,0-2.1-7.812,56.014,56.014,0,0,1,7.127,4.5A9.7,9.7,0,0,1,898.132,620.215Z",
    transform: "translate(-718.318 -599.011)",
    fill: "#231f20"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31158",
    "data-name": "Path 31158",
    d: "M782.951,600.594s-35.426-2.184-50.615,1.17c-8.457,1.867-25.3,11.869-32.765,18.592h59.871a6.539,6.539,0,0,0,5.084-2.44C770.236,610.851,777.958,603.481,782.951,600.594Z",
    transform: "translate(-647.187 -597.544)",
    fill: "#b8fffb"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31159",
    "data-name": "Path 31159",
    d: "M1006.006,655.7l-.045-.195-.006-.026-.165-.718-.015-.065-.065-.279-.014-.063-.071-.309,0-.007q-.035-.155-.07-.3l-.016-.067-.052-.222-.01-.045a5.615,5.615,0,0,0-2.482-3.48l-.133-.085-.089-.056-.38-.241-.329-.21-.03-.019-.311-.2-.077-.049-.283-.183-.342-.223-.461-.3-.394-.26-.15-.1-.05-.034-.474-.316-.062-.041h0l-2.5,1.2a1.53,1.53,0,0,0-.419,2.482l2.3,2.246a7.656,7.656,0,0,0,5.354,2.173Z",
    transform: "translate(-795.32 -621.38)",
    fill: "#c42731"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31160",
    "data-name": "Path 31160",
    d: "M999.51,654.35c.646.631,4.841.3,7.269-.317a5.636,5.636,0,0,0-2.056-2.286l-.133-.085-.089-.056-.38-.241-.173-.111A12.962,12.962,0,0,1,999.51,654.35Z",
    transform: "translate(-797.049 -623.204)",
    fill: "#ffa1a1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31161",
    "data-name": "Path 31161",
    d: "M1000.538,656.756a7.656,7.656,0,0,0,5.354,2.173h1.843l-.044-.195-.006-.026q-.085-.371-.165-.719l-.014-.065-.065-.279-.015-.063-.071-.309,0-.008c-.024-.1-.047-.2-.07-.3l-.016-.067-.052-.222-.01-.045a5.6,5.6,0,0,0-1.378-2.569c-1.98.625-4.181,1.206-6.317,1.692Z",
    transform: "translate(-797.049 -624.606)",
    fill: "#872b34"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31162",
    "data-name": "Path 31162",
    d: "M639.184,667.312H668.3c4.537,0,5.217-.382,9.687-2.373,2.247-1,.3-1.9.3-1.9-6.317,3.318-7.4,3.359-20.22,3.359H639.843c-1.924,0-4.7-2.209-3.6-5.171q-1.045.666-1.96,1.35C634.1,665.566,636.756,667.312,639.184,667.312Z",
    transform: "translate(-614.564 -628.185)",
    fill: "#353538"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31163",
    "data-name": "Path 31163",
    d: "M620.528,674.579a10.788,10.788,0,0,0,5.206-1.686,1.8,1.8,0,0,0,.368-2.529l-1.349-1.893A19.162,19.162,0,0,0,620.528,674.579Z",
    transform: "translate(-607.694 -631.806)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31164",
    "data-name": "Path 31164",
    d: "M626.346,675.734a8.187,8.187,0,0,1-4.7.288,18.6,18.6,0,0,0-1.121,2.186,10.786,10.786,0,0,0,5.206-1.686A1.618,1.618,0,0,0,626.346,675.734Z",
    transform: "translate(-607.694 -635.435)",
    fill: "#aae6e2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31165",
    "data-name": "Path 31165",
    d: "M739.863,637.085c15.327-2.4,40.783-3.652,43.944-.948C780.537,638.069,745.918,637.394,739.863,637.085Z",
    transform: "translate(-667.319 -614.889)",
    fill: "#596b6a"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31166",
    "data-name": "Path 31166",
    d: "M806.652,618.806h0a7.861,7.861,0,0,0-7.668,6.128l-1.078,4.766h13.16l.947-4.185A5.5,5.5,0,0,0,806.652,618.806Z",
    transform: "translate(-696.319 -606.992)",
    fill: "#596b6a"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31167",
    "data-name": "Path 31167",
    d: "M782.951,600.594s-35.426-2.184-50.615,1.17c-8.457,1.867-25.3,11.869-32.765,18.592h7c7.365-6.234,22.305-14.791,33.8-14.459a107.7,107.7,0,0,0-6.456,14.459h9.2a131.977,131.977,0,0,1,5.043-14.469c7.218.342,15.033,3.451,19.5,8.346C772.837,608.427,778.825,602.98,782.951,600.594Z",
    transform: "translate(-647.187 -597.544)",
    fill: "#596b6a"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31168",
    "data-name": "Path 31168",
    d: "M703.1,619.392c6.509-3.275,15.793-8.1,34.4-8.1,22.842,0,30.4.945,35.068-2.4s10.287-8.163,10.287-8.163-32.5-2.348-46.035.494S704.88,617.145,703.1,619.392Z",
    transform: "translate(-648.953 -597.505)",
    fill: "#fff",
    opacity: 0.61
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31169",
    "data-name": "Path 31169",
    d: "M759.011,620.357H699.139a.432.432,0,0,1-.289-.754c7.4-6.666,24.406-16.8,32.961-18.693,5.647-1.246,14.657-1.879,26.78-1.879,12.462,0,23.841.693,23.954.7a.433.433,0,0,1,.19.806c-4.775,2.762-12.473,10-18.3,17.22A6.943,6.943,0,0,1,759.011,620.357ZM700.907,619h57.362a6.083,6.083,0,0,0,4.748-2.279,91.642,91.642,0,0,1,14.494-14.585c.726-.557,2.716-1.736.813-1.757-4.433-.049-11.864-.481-19.733-.481-12.061,0-21.008.625-26.594,1.859C723.876,603.548,708.62,612.414,700.907,619Z",
    transform: "translate(-646.755 -597.111)",
    fill: "#231f20"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31170",
    "data-name": "Path 31170",
    d: "M842.58,640.211c1,.99,3.809,1.484,7.35,1.484s1.339-1.565-.176-1.565S842.58,640.211,842.58,640.211Z",
    transform: "translate(-718.64 -617.646)",
    fill: "#231f20"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60306",
    "data-name": "Group 60306",
    transform: "translate(101.784 42.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31171",
    "data-name": "Path 31171",
    d: "M821.895,700.111c0,10.733-5.282,19.5-11.8,19.433-6.586-.065-11.829-8.73-11.8-19.433.032-10.733,5.282-19.434,11.8-19.434S821.895,689.379,821.895,700.111Z",
    transform: "translate(-798.301 -680.678)",
    fill: "#2f2f36"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3208",
    "data-name": "Ellipse 3208",
    cx: 9.277,
    cy: 16.27,
    rx: 9.277,
    ry: 16.27,
    transform: "translate(2.52 3.164)",
    fill: "#b4b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31172",
    "data-name": "Path 31172",
    d: "M807.915,719.139l13.895-17.257c-.565-4.738-2.3-8.719-4.661-10.962l-13.582,16.87C804,712.6,805.635,716.707,807.915,719.139Z",
    transform: "translate(-800.932 -685.795)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3209",
    "data-name": "Ellipse 3209",
    cx: 7.589,
    cy: 14.181,
    rx: 7.589,
    ry: 14.181,
    transform: "translate(4.208 5.252)",
    fill: "#6c6e73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3210",
    "data-name": "Ellipse 3210",
    cx: 5.329,
    cy: 13.542,
    rx: 5.329,
    ry: 13.542,
    transform: "translate(4.208 5.892)",
    fill: "#48494d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31173",
    "data-name": "Path 31173",
    d: "M815.945,713.139a18.657,18.657,0,0,0-.683-4.038l-2.831,2.32a8.413,8.413,0,0,1,.4,1.717Z",
    transform: "translate(-805.36 -694.88)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31174",
    "data-name": "Path 31174",
    d: "M815.151,726.316a18.493,18.493,0,0,0,.718-3.958h-3.132a8.186,8.186,0,0,1-.427,1.631Z",
    transform: "translate(-805.3 -701.503)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31175",
    "data-name": "Path 31175",
    d: "M811.887,700.805a11.931,11.931,0,0,0-.733-1.221,8.8,8.8,0,0,0-1.23-1.442l-.028.045c-.188.312-.366.636-.535.97a18.416,18.416,0,0,0-1.438,4.119,1.261,1.261,0,0,1,.629.263Z",
    transform: "translate(-803.108 -689.404)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31176",
    "data-name": "Path 31176",
    d: "M808.409,730.292a1.076,1.076,0,0,1-.486.17,18.374,18.374,0,0,0,1.439,4.121c.169.332.346.655.533.965l.029.048a8.8,8.8,0,0,0,1.23-1.442,11.75,11.75,0,0,0,.655-1.075Z",
    transform: "translate(-803.108 -705.467)",
    fill: "#231f20"
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31177",
    "data-name": "Path 31177",
    d: "M956.754,660.772l5.223.072a1.138,1.138,0,0,0,1.114-1.161h0c0-.017,0-.034,0-.051h-7.416A1.134,1.134,0,0,0,956.754,660.772Z",
    transform: "translate(-775.146 -627.39)",
    fill: "#6c6e73"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31178",
    "data-name": "Path 31178",
    d: "M899.873,660.767l5.583.076a1.175,1.175,0,0,0,1.19-1.16h0c0-.017,0-.034,0-.051h-7.928A1.173,1.173,0,0,0,899.873,660.767Z",
    transform: "translate(-746.689 -627.39)",
    fill: "#6c6e73"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31179",
    "data-name": "Path 31179",
    d: "M960.92,659.641l2.369-2.316-2.126-.029-2.368,2.316Z",
    transform: "translate(-776.705 -626.223)",
    fill: "#fff",
    opacity: 0.27
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31180",
    "data-name": "Path 31180",
    d: "M902.594,657.26l-2.307,2.256a1.171,1.171,0,0,0,.371.066l2.31.032,2.369-2.316Z",
    transform: "translate(-747.473 -626.205)",
    fill: "#fff",
    opacity: 0.45
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31181",
    "data-name": "Path 31181",
    d: "M898.717,659.2s7.908-1,7.93.051C905.68,659.251,898.717,659.2,898.717,659.2Z",
    transform: "translate(-746.689 -626.958)",
    fill: "#fff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31182",
    "data-name": "Path 31182",
    d: "M955.67,659.2s7.4-1,7.42.051C962.186,659.251,955.67,659.2,955.67,659.2Z",
    transform: "translate(-775.145 -626.958)",
    fill: "#fff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31183",
    "data-name": "Path 31183",
    d: "M856.642,633.241l1.581-2.124a5.792,5.792,0,0,1,5.158-2.293l1.379.122a13.619,13.619,0,0,1,6.808,2.543l.309.225a2.288,2.288,0,0,1,.338,3.422h0a2.818,2.818,0,0,1-2.064.9h-13.2Z",
    transform: "translate(-725.666 -611.986)",
    fill: "#231f20"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31184",
    "data-name": "Path 31184",
    d: "M871.877,631.714l-.309-.225a13.619,13.619,0,0,0-6.808-2.543l-1.379-.122a5.792,5.792,0,0,0-5.158,2.293l-1.581,2.124.138,1.229h15.867A2.289,2.289,0,0,0,871.877,631.714Z",
    transform: "translate(-725.666 -611.986)",
    fill: "#333636"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31185",
    "data-name": "Path 31185",
    d: "M872.488,631.714l-.309-.225a13.617,13.617,0,0,0-6.808-2.543l-1.379-.122a5.792,5.792,0,0,0-5.158,2.293l-.969,1.3h0c3.242-2.376,12.063-2.749,15.531.71A2.289,2.289,0,0,0,872.488,631.714Z",
    transform: "translate(-726.278 -611.986)",
    fill: "#a3a8a8"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60307",
    "data-name": "Group 60307",
    transform: "translate(63.064 35.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31186",
    "data-name": "Path 31186",
    d: "M721.472,671.276l11.61-3.326a57.171,57.171,0,0,1,26.484-1.164h0l-4.688,4.992a14.016,14.016,0,0,1-10.088,4.278l-11.659.1a20.488,20.488,0,0,1-11.908-3.626h0A.694.694,0,0,1,721.472,671.276Z",
    transform: "translate(-720.916 -665.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31187",
    "data-name": "Path 31187",
    d: "M745.1,677.084a14.016,14.016,0,0,0,10.088-4.278l4.688-4.992h0c-12.651,9.2-32.789,8.13-38.343,5.744a20.489,20.489,0,0,0,11.908,3.626Z",
    transform: "translate(-721.223 -666.785)",
    fill: "#b8c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31188",
    "data-name": "Path 31188",
    d: "M725.525,675.67c3.274-3.268,14.878-6.484,26.986-5.356C750.113,675.555,730.641,677.474,725.525,675.67Z",
    transform: "translate(-723.219 -667.919)",
    fill: "#b8c9c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M761.232,675.456a3.008,3.008,0,1,1-3.03-3.166A3.1,3.1,0,0,1,761.232,675.456Z",
    transform: "translate(-738.059 -669.021)",
    fill: "#fff",
    opacity: 0.63
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M745.008,678.225a2.184,2.184,0,1,1-2.2-2.3A2.252,2.252,0,0,1,745.008,678.225Z",
    transform: "translate(-730.775 -670.838)",
    fill: "#fff",
    opacity: 0.63
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M748.008,707.943l-5.3-9.422a2.731,2.731,0,0,0-2.3-1.254H735.28a9.106,9.106,0,0,1,1.229,8.631c-1.668,5.182-10.875,6.8-15.232,6.673l1.586.667a8.447,8.447,0,0,0,4.243.407l19.677-3.163A1.719,1.719,0,0,0,748.008,707.943Z",
    transform: "translate(-658.032 -646.194)",
    fill: "#231f20"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31192",
    "data-name": "Path 31192",
    d: "M758.475,718.17h0a.618.618,0,0,0,.618.618h7.718a1.718,1.718,0,0,0-.217-.709l-.3-.526h-7.2A.618.618,0,0,0,758.475,718.17Z",
    transform: "translate(-676.618 -656.329)",
    fill: "#353536"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31193",
    "data-name": "Path 31193",
    d: "M763.915,711.964h-6.446a.618.618,0,0,0,0,1.236h7.141Z",
    transform: "translate(-675.807 -653.537)",
    fill: "#353536"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31194",
    "data-name": "Path 31194",
    d: "M761.531,706.376h-5.687a.618.618,0,0,0,0,1.236h6.382Z",
    transform: "translate(-674.995 -650.745)",
    fill: "#353536"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31195",
    "data-name": "Path 31195",
    d: "M759.147,700.788H754.22a.618.618,0,0,0,0,1.236h5.622Z",
    transform: "translate(-674.183 -647.953)",
    fill: "#353536"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60308",
    "data-name": "Group 60308",
    transform: "translate(15.793 43.893)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6060",
    "data-name": "Rectangle 6060",
    width: 41.809,
    height: 1.236,
    transform: "translate(1.603 0)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6061",
    "data-name": "Rectangle 6061",
    width: 44.844,
    height: 1.236,
    transform: "translate(0 3.284)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6062",
    "data-name": "Rectangle 6062",
    width: 43.792,
    height: 1.236,
    transform: "translate(0.196 6.567)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6063",
    "data-name": "Rectangle 6063",
    width: 40.455,
    height: 1.236,
    transform: "translate(1.603 9.852)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6064",
    "data-name": "Rectangle 6064",
    width: 37.613,
    height: 1.236,
    transform: "translate(2.651 13.135)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6065",
    "data-name": "Rectangle 6065",
    width: 34.057,
    height: 1.236,
    transform: "translate(3.883 16.419)",
    fill: "#48494a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31196",
    "data-name": "Path 31196",
    d: "M629.645,702.608h.753l-.753.5Z",
    transform: "translate(-628.042 -692.756)",
    fill: "#353536"
  }))), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31197",
    "data-name": "Path 31197",
    d: "M657.028,700.578H634.919a6.539,6.539,0,0,1-5.924-3.8l-.018-.045-3.687-10.012a6.258,6.258,0,0,1,1.561-6.7l2.463-2.337a6.492,6.492,0,0,1,3.926-1.331h29.938a6.433,6.433,0,0,1,3.689,1.157l.045.035,2.024,1.708a6.286,6.286,0,0,1,1.248,8.14l-6.07,9.566A8.776,8.776,0,0,1,657.028,700.578Zm-26.9-4.292a5.3,5.3,0,0,0,4.791,3.056h22.109a7.535,7.535,0,0,0,6.074-3.09l6.038-9.518a5.045,5.045,0,0,0-1-6.534l-2-1.689a5.2,5.2,0,0,0-2.96-.92H633.239a5.253,5.253,0,0,0-3.15,1.057l-2.388,2.271a5.022,5.022,0,0,0-1.253,5.379Z",
    transform: "translate(-609.88 -635.745)",
    fill: "#a7a9ac"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60309",
    "data-name": "Group 60309",
    transform: "translate(15.996 40.609)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31198",
    "data-name": "Path 31198",
    d: "M631.1,707.521l-3.2-8.68-1.055.713,3.1,8.418.018.044a6.538,6.538,0,0,0,3.951,3.488l1.416-.957A5.3,5.3,0,0,1,631.1,707.521Z",
    transform: "translate(-626.848 -687.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31199",
    "data-name": "Path 31199",
    d: "M660.391,676.355l-1.828,1.236H680a5.19,5.19,0,0,1,2.428.6l1.131-.765a6.426,6.426,0,0,0-3.559-1.07Z",
    transform: "translate(-642.694 -676.355)",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60310",
    "data-name": "Group 60310",
    transform: "translate(188.605 42.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31200",
    "data-name": "Path 31200",
    d: "M993.006,700.111c0,10.733-4.744,19.5-10.595,19.433-5.915-.065-10.624-8.73-10.595-19.433.03-10.733,4.744-19.434,10.595-19.434S993.006,689.379,993.006,700.111Z",
    transform: "translate(-971.817 -680.678)",
    fill: "#2f2f36"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3211",
    "data-name": "Ellipse 3211",
    cx: 8.332,
    cy: 16.27,
    rx: 8.332,
    ry: 16.27,
    transform: "translate(2.263 3.164)",
    fill: "#b4b7bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31201",
    "data-name": "Path 31201",
    d: "M993.068,705.88c0-5.724-1.514-10.756-3.8-13.656l-12.8,15.694c.358,5.592,2.168,10.3,4.671,12.643l11.927-14.628C993.067,705.916,993.068,705.9,993.068,705.88Z",
    transform: "translate(-974.142 -686.447)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3212",
    "data-name": "Ellipse 3212",
    cx: 6.815,
    cy: 14.181,
    rx: 6.815,
    ry: 14.181,
    transform: "translate(3.779 5.252)",
    fill: "#6c6e73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3213",
    "data-name": "Ellipse 3213",
    cx: 4.786,
    cy: 13.542,
    rx: 4.786,
    ry: 13.542,
    transform: "translate(3.779 5.892)",
    fill: "#48494d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31202",
    "data-name": "Path 31202",
    d: "M987.662,713.139a20.607,20.607,0,0,0-.614-4.038l-2.543,2.32a9.2,9.2,0,0,1,.362,1.717Z",
    transform: "translate(-978.156 -694.88)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31203",
    "data-name": "Path 31203",
    d: "M986.949,726.316a20.365,20.365,0,0,0,.645-3.958h-2.813a8.958,8.958,0,0,1-.383,1.631Z",
    transform: "translate(-978.103 -701.503)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31204",
    "data-name": "Path 31204",
    d: "M984.019,700.805a12.305,12.305,0,0,0-.658-1.221,8.58,8.58,0,0,0-1.105-1.442l-.024.045c-.169.312-.329.636-.481.97a19.85,19.85,0,0,0-1.292,4.119,1.072,1.072,0,0,1,.565.263Z",
    transform: "translate(-976.134 -689.404)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31205",
    "data-name": "Path 31205",
    d: "M980.894,730.292a.9.9,0,0,1-.436.17,19.827,19.827,0,0,0,1.292,4.121c.151.332.311.655.479.965l.026.048a8.58,8.58,0,0,0,1.105-1.442,12.171,12.171,0,0,0,.589-1.075Z",
    transform: "translate(-976.134 -705.467)",
    fill: "#231f20"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_60311",
    "data-name": "Group 60311",
    transform: "translate(123.622 9.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31206",
    "data-name": "Path 31206",
    d: "M949.673,625.338c-.514-.227-1.094-.474-1.74-.736.264.8.5,1.606.722,2.4q.865.247,1.617.474C950.09,626.776,949.891,626.057,949.673,625.338Z",
    transform: "translate(-894.9 -619.077)",
    fill: "#3c3c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31207",
    "data-name": "Path 31207",
    d: "M849.083,626.314l-.323-2.88c.673-.747,1.362-1.478,2.07-2.187a37.013,37.013,0,0,0-3.376,1.8c-1.8,2.028-3.474,4.125-5.08,6.09a1.175,1.175,0,0,0-.135.209l-.07.084a.957.957,0,0,0-.225.531A53.4,53.4,0,0,1,849.083,626.314Z",
    transform: "translate(-841.944 -617.401)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31208",
    "data-name": "Path 31208",
    d: "M904.735,618.04c1.535.034,3.035.117,4.492.237-.412-1.406-.887-2.847-1.426-4.216q-2.157-.348-4.352-.5C903.973,615.111,904.4,616.622,904.735,618.04Z",
    transform: "translate(-872.675 -613.561)",
    fill: "#3c3c40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.552c0db93023c7afe4b6483b160c9158.svg";
export { ForwardRef as ReactComponent };